<template>
	<div class="box vh-140">
		<div class="box-header">
			<i class="fa fa-th-large"></i>
			<h3 class="box-title">用户列表</h3>
		</div>
		<div class="box-body">
			<el-row class="margin-bottom-15" :gutter="10">
				<el-col :span="16">
					<el-button type="primary" size="small" @click="toSaveUser" plain><i class="fa fa-plus"></i> 添加</el-button>
					<el-button size="small" @click="doInitPwd" plain><i class="fa fa-crosshairs"></i> 重置密码</el-button>
				</el-col>
			</el-row>


			<el-table
				class="list-table"
				ref="multipleTable"
				:data="userList"
				:header-cell-style="{ background: '#eef1f6', color: '#606266' }"
				stripe
				border
				tooltip-effect="dark"
				@selection-change="handleSelectionChange"
			>
				<template slot="empty">
					<div class="no-data">暂无数据！</div>
				</template>
				<el-table-column type="selection" width="55" prop="id"></el-table-column>
				<el-table-column type="index" label="序号" width="60"></el-table-column>
				<el-table-column prop="loginName" label="用户名" min-width="140"></el-table-column>
				<el-table-column prop="trueName" label="姓名" min-width="100"></el-table-column>
				<el-table-column prop="sex" label="性别" width="50">
					<template slot-scope="scope">{{ scope.row.sex == 0 ? '男' : '女' }}</template>
				</el-table-column>
				<el-table-column prop="phone" label="电话" min-width="120"></el-table-column>
				<el-table-column prop="email" label="邮箱" min-width="140"></el-table-column>
				<el-table-column prop="status" label="是否启用" width="100" v-if="false">
					<!--<template slot-scope="scope">-->
					<!--<el-tag :type="scope.row.status === 0 ? 'success' : 'danger'" close-transition>{{scope.row.status==0?'正常':'锁定'}}</el-tag>-->
					<!--</template>-->
					<template slot-scope="scope">
						<el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ff4949" :active-value="0" @change="switchStatue(scope.row)" :inactive-value="1"> </el-switch>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" min-width="150">
					<template slot-scope="scope">
						<el-button @click.prevent="toEditUser(scope.row)" type="text" size="small"><i class="fa fa-edit"></i> 编辑 </el-button>
						<el-button @click.prevent="deleteUser(scope.row.id)" type="text" size="small"><i class="fa fa-trash-o"></i> 删除 </el-button>
						<el-button @click.prevent="userAuth(scope.row)" type="text" size="small"><i class="fa fa-gavel"></i> 用户授权 </el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 分页-->
		<page-bar v-model="page" @change="fetchData"></page-bar>


    <auth-user :visible="authDialog" :echo="curUser" @done="saveFinish"></auth-user>

    <user-save :visible="userDialog" :user="curUser" @done="saveFinish"></user-save>
	</div>
</template>

<script>
import { fetchList, remove, freeze, unfreeze, initPassword } from '@api/system/user'
import PageBar from '@components/PageBar'
import AuthUser from './authUser'
import UserSave from './userSave'
import { handleConfirm } from '@utils/confirm'

export default {
	name: 'sys-user',
	created() {
		this.fetchData()
	},
	components: { PageBar,AuthUser,UserSave },
	methods: {
		fetchData() {
			fetchList({
				pageNo: this.page.pageNo,
				pageSize: this.page.pageSize,
				param: this.page.param
			}).then(resp => {
        let data = resp.data.result
        this.$set(this.page, 'total', data.total)
        this.$set(this.page, 'pageNo', data.pageNo)
        this.$set(this.page, 'pageSize', data.pageSize)
        this.userList = data.records
			})
		},
		toEditUser(val) {
      this.userDialog = true
		  this.curUser = val
		},
		toSaveUser() {
		  this.curUser = null
		  this.userDialog = true
		},
		switchStatue(val) {
			if (val.status === 0) {
				unfreeze(val.id).then(resp => {
				  this.$message.success(resp.data.message)
				})
			} else {
				freeze(val.id).then(resp => {
          this.$message.success(resp.data.message)
				})
			}
		},
		userAuth(val) {
		  this.authDialog = true
      this.curUser = val
		},
    saveFinish(flag = false){
      this.authDialog = false
      this.userDialog = false
      if(flag){
        this.fetchData()
      }
    },
		deleteUser(val) {
			handleConfirm('此操作将永久删除该用户的所有信息, 是否继续?').then(() => {
				remove(val).then(resp => {
					this.$message.success(resp.data.message)
					this.fetchData()
				})
			})
		},
		doInitPwd() {
			let ids = this.multipleSelection.map(row => {return row.id})
			if(ids.length>0){
				handleConfirm('重置后的默认密码是123456, 是否继续?').then(() => {
					initPassword(ids).then(resp => {
						if (resp.data.code === 200) {
							this.$message.success(resp.data.message)
							this.$refs.multipleTable.clearSelection()
						}
					})
				})
			}else{
				this.$message.warning('请选择需要操作的用户！')
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val
		}
	},
	data() {
		return {
			page: {
				pageSize: 20,
				pageNo: 1
			},
			userList: [],
      curUser: null,
      authDialog: false,
      userDialog: false,
			multipleSelection: []
		}
	}
}
</script>

